(() => {
  function initPriceMirror() {
    const duplicates = document.querySelectorAll('[data-price-sync]');
    if (!duplicates.length) return;

    duplicates.forEach((dup) => {
      const fromId = dup.getAttribute('data-price-sync-from');
      if (!fromId) return;

      const src = document.getElementById(fromId);
      if (!src) return;

      const sync = () => {
        dup.innerHTML = src.innerHTML;
      };

      sync();

      const mo = new MutationObserver(sync);
      mo.observe(src, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initPriceMirror);
})();
